import React, { Fragment } from 'react';

import Tooltip from 'elements/Tooltip/Tooltip';
import {
  Layout,
  Row,
  Title,
  Item,
  Label,
  List,
  ListElement,
  Description,
  MapTooltipIcons,
  MapTooltipPoints,
  MapFlag
  } from 'elements/Tooltip/Layout';
import Divider from 'elements/Divider/Divider';
import { DIVIDERS } from 'common/constants';
import ActionIcon from 'elements/ActionIcons/ActionIcon';
import { iconSet } from '@containers/components/Map/constants/clustersAndOrders';

const listItems = ['list element', 'list element', 'list element', 'list element'];

const dafeult1 = () => (
  <Layout>
    <Row>
      <Title>Title</Title>
    </Row>
    <Row>
      <Description>
        Description Text Here Two lines
      </Description>
    </Row>
    <Row spaceBetween>
      <Label>
        Label
      </Label>
      <ListElement>
        list element
      </ListElement>
    </Row>
    <Row spaceBetween>
      <Label>
        Label
      </Label>
      <ListElement>
        list element
      </ListElement>
    </Row>
  </Layout>
);

const default2 = () => (
  <Layout>
    <Row>
      <Title>Title</Title>
    </Row>
    <Row>
      <List items={listItems}/>
      <List items={listItems}/>
      <List items={listItems}/>
    </Row>
  </Layout>
);

const default3 = () => (
  <Layout>
    <Row>
      <Title>Title</Title>
    </Row>
    <Row spaceBetween>
      <Label>
        Label
      </Label>
      <Label>
        Label
      </Label>
    </Row>
    <Row spaceBetween>
      <Item>
        item
      </Item>
      <Item>
        item
      </Item>
    </Row>
    <Divider layout={DIVIDERS.tooltip} />
    <Row>
      <List items={listItems}/>
      <List items={listItems}/>
    </Row>
  </Layout>
);

const tooltipLayouts = {
  default1: dafeult1(),
  default2: default2(),
  default3: default3()
};

/* eslint-disable react/prop-types */
export const DefaultTooltip = ({ __layout = 'default1', placement, whiteBackground, purpleBackground }) => {
  return (
    <Tooltip
      target={<ActionIcon icon="information" type="40" />}
      placement={placement}
      whiteBackground={whiteBackground}
      purpleBackground={purpleBackground}
    >
      {tooltipLayouts[__layout]}
    </Tooltip>
  );
};

export const WithIconsTooltip = ({ __secondaryLayout, placement, withCloseButton, whiteBackground, purpleBackground }) => {
  return (
    <Tooltip
      target={<ActionIcon icon="information" type="40" />}
      placement={placement}
      whiteBackground={whiteBackground}
      purpleBackground={purpleBackground}
      withCloseButton={withCloseButton}
      click={withCloseButton}
    >
      {
        __secondaryLayout
          ?
            <Layout>
              <Row>
                <Label inline>ITFS LINE 2</Label>
                <MapTooltipIcons icons={iconSet} />
              </Row>
              <Row spaceBetween>
                <MapTooltipPoints from="Portugal" to="India" />
              </Row>
            </Layout>
          :
            <Layout>
              <Row>
                <Title>Title</Title>
              </Row>
              <Row>
                <Description>
                  Description Text Here
                </Description>
              </Row>
            </Layout>
      }
    </Tooltip>
  );
};

export const WithFlagTooltip = ({ __layout, placement }) => {
  return (
    <Tooltip
      target={<ActionIcon icon="information" type="40" />}
      placement={placement}
      open
    >
      <Row spaceBetween>
        {
          __layout === 'left'
            ?
              <Fragment>
                <MapFlag title="Title" flag="india" />
                <ActionIcon icon="link-arrow-right-17" type="other" darkBg />
              </Fragment>

            :
              <MapFlag title="Title" flag="india" flagRight/>
        }
      </Row>
      <Row spaceBetween>
        <Label>
          Label
        </Label>
        <ListElement>
          list element
        </ListElement>
      </Row>
      <Row spaceBetween>
        <Label>
          Label
        </Label>
        <ListElement>
          list element
        </ListElement>
      </Row>
      <Row spaceBetween>
        <Label>
          Label
        </Label>
        <ListElement>
          list element
        </ListElement>
      </Row>
    </Tooltip>
  );
};
/* eslint-enable react/prop-types */



// WEBPACK FOOTER //
// ./src/containers/elements/Tooltips/constants/tooltipLayouts.js